export default __webpack_public_path__ + "static/Completeness-0c42b0244765f7c156716b528f4ad09d.svg";